<time :datetime="formattedDate">{{ formattedDate }}</time>